module.exports = __webpack_public_path__ + "media/images/area/icon_weather_28-bfcc8ba95db1eb9d28d60bfd3c47b519.png";